import PropTypes from "prop-types";
import * as React from "react";
import { Box, Button, TextInput } from "../../themeV2";

export default function EmailStep({ onContinue }) {
  const [email, setEmail] = React.useState("");
  const [problem, setProblem] = React.useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();

    return email.trim()
      ? onContinue(email)
      : setProblem("Please enter your email address");
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Box direction="column" gap={4}>
        <TextInput
          type="email"
          label="Email"
          variant="filled"
          autoComplete="username webauthn"
          autoFocus
          required
          value={email}
          onValueChange={setEmail}
          error={problem ?? undefined}
        />

        <Button type="submit" fullWidth>
          Continue
        </Button>
      </Box>
    </form>
  );
}

EmailStep.propTypes = {
  onContinue: PropTypes.func.isRequired,
};
